import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import { createMigrate } from "redux-persist";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import storage from "redux-persist/lib/storage";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";
import alcoholSlice from "./slices/alcoholSlice";
import drinkCacheSlice from "./slices/drinkCache";
import drinkSelectionSlice from "./slices/drinkSelectionSlice";
import locationSlice from "./slices/locationSlice";
import migrations from "./slices/migrations/migrations";
import ownItemsSlice from "./slices/ownItems";
import syncSlice from "./slices/syncSlice";
import userSlice from "./slices/userSlice";

const persistConfig = {
  key: "root",
  storage,
  version: 2,
  migrate: createMigrate(migrations),
};

const rootReducer = combineReducers({
  user: userSlice,
  drinkSelection: drinkSelectionSlice,
  alcohol: alcoholSlice,
  sync: syncSlice,
  location: locationSlice,
  ownItems: ownItemsSlice,
  drinkCache: drinkCacheSlice,
});

const logger = createLogger({
  collapsed: (getState, action, logEntry) => !logEntry.error,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const createStoreAndPersistor = () => {
  let store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(
          createStateSyncMiddleware({
            blacklist: ["persist/PERSIST", "persist/REHYDRATE"],
          })
        )
        .concat(logger),
  });
  initMessageListener(store);
  let persistor = persistStore(store);
  return { store, persistor };
};

export default createStoreAndPersistor;
